import Clipboard from "clipboard";
import { show as showNotification } from "common/notifications";

window.ClipboardJS = Clipboard;

const fallbackMessage = function (action) {
  let actionMsg = "";
  const actionKey = action === "cut" ? "X" : "C";
  if (/iPhone|iPad/i.test(navigator.userAgent)) {
    actionMsg = "No support :(";
  } else if (/Mac/i.test(navigator.userAgent)) {
    actionMsg = `Press ⌘-${actionKey} to ${action}`;
  } else {
    actionMsg = `Press Ctrl-${actionKey} to ${action}`;
  }
  return actionMsg;
};

const initializeClipboard = (selector) => {
  const clipboard = new Clipboard(selector);
  clipboard.on("success", () =>
    showNotification(window.TC_LABELS.COPIED, {
      id: "copyButtonMessage",
      type: "success",
    })
  );
  clipboard.on("error", (e) =>
    showNotification(fallbackMessage(e.action), {
      id: "copyButtonMessage",
      type: "error",
    })
  );
  return clipboard;
};

export default function copyToClipboard(element) {
  const clipboard = initializeClipboard(element);
  return () => clipboard.destroy();
}

window.copyToClipboard = copyToClipboard;
